module.exports = __webpack_public_path__ + "img/palm0_2.9d5ed643.png";